<!--
 @description 自动巡检报告
 @author xiehan
 @date 2020/03/09
-->
<template>
    <div class="autoInspectionReport__content">
      <el-form ref="searchForm" :model="searchForm" :inline="true" input-width="auto">
        <el-form-item :label="$t('logComponentManage.site')">
          <g-select :list="siteList" v-model="searchForm.siteCode"></g-select>
        </el-form-item>
        <el-form-item :label="$t('autoInspectionReport.system')">
          <g-select :list="select_system" v-model="searchForm.system" @change="getResource()" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('autoInspectionReport.resourceType')">
          <g-select :list="select_resource" v-model="searchForm.resourceType" @change="getItem()" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('autoInspectionReport.host')">
          <el-input v-model="searchForm.host" ></el-input>
        </el-form-item>
        <el-form-item :label="$t('autoInspectionReport.item')">
          <g-select :list="select_item" v-model="searchForm.item" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('autoInspectionReport.resultType')">
          <g-select :list="select_result" v-model="searchForm.resultType" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('autoInspectionReport.inspectionTime')" input-width="auto">
          <el-form-item prop="startTime">
            <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.startTime" type="datetime">
            </el-date-picker>
          </el-form-item>
          <span v-text="$t('common.to')"></span>
          <el-form-item prop="endTime" style="margin-left: 10px">
            <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.endTime" type="datetime">
            </el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item input-width="auto">
          <el-button type="primary" 
            @click="search"
            v-g-rac="gRac('autoInspectionReport@search')"
            v-text="$t('common.search')"></el-button>
          <el-button type="primary" 
            @click="e_export"
            v-g-rac="gRac('autoInspectionReport@export')"
            v-text="$t('accidentEntry.export')"></el-button>
        </el-form-item>
      </el-form>
      <el-table-extend
        :data="tData" 
        :head="tHead" 
        :currentChange="tCurrentChange" 
        :sizeChange="tSizeChange"
        border>
      </el-table-extend>
    </div>
  </template>
  
  <script>
    import autoInsepctionBiz from '@/logic/systemDiagram/autoInspectionBiz.js'
    import SiteListBiz from '@/logic/cmdb/cmdbBiz'
    import dic from '@/components/mixins/dic'
    import table from '@/components/mixins/table'
    import exportTips from '@/components/mixins/exportTips'
    import TimeFormat from '@/utils/timeFormat'
    import { extend } from '@/utils/tool'
    import rac from '@/plugins/rac-mixin.js'
    const DIC_MAP = {
      system: 'systemmoduletype',
      result: 'resultmoduletype'
    }
    export default {
      mixins: [dic, table, rac, exportTips],
      data () {
        return {
          siteList: {},
          select_system: {},
          select_resource: {},
          select_item: {},
          select_result: {},
          doExport: null,
          searchForm: {
            siteCode: '',
            startTime: new Date(new Date().toLocaleDateString()).getTime(),
            endTime: '',
            system: '',
            resourceType: '',
            host: '',
            item: '',
            resultType: ''
          },
        }
      },
      methods: {
        async preInitTable () {
          await Promise.all([
            this.getResource(true),
            this.getItem(),
            this.dGetDictionaryByCode('systemmoduletype'),
            this.dGetDictionaryByCode('resultmoduletype')
          ])
          this.select_system = { ...this.dDictionary.systemmoduletype }
          this.select_result = { ...this.dDictionary.resultmoduletype }
          this.initTable()
        },
        initTable () {
          this.tInitTable({
            lanKey: 'autoInspectionReport.table',
            head: ['time', 'siteCode', 'system', 'resourceType', 'host', 'item', 'result', 'explain'],
            requestFun: this.searchTable,
            headOpt: {
              item: {
                formatter: 'Dictionary',
                formatterDic: this.select_item
              },
              system: {
                formatter: 'Dictionary',
                formatterDic: this.select_system
              },
              resourceType: {
                formatter: 'Dictionary',
                formatterDic: this.select_resource
              },
              result: {
                formatter: 'Dictionary',
                formatterDic: this.select_result
              },
              siteCode: {
                formatter: 'Dictionary',
                formatterDic: this.siteList
              }
            }
          })
        },
        search () {
          this.tResetPage()
          this.searchTable()
        },
        searchTable () {
          const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
          if (!reqData.endTime) reqData.endTime = new Date().getTime()
          if (!reqData.system) reqData.system = 0
          if (!reqData.resourceType) reqData.resourceType = ''
          if (!reqData.resultType) reqData.resultType = 0
          if (!reqData.item) reqData.item = 0
          // Object.keys(reqData).map(item => {
          //   if (reqData[item] === '') delete reqData[item]
          // })
          autoInsepctionBiz.getResult(reqData).then((data) => {
            if (data && data.dataList) {
              data.dataList.map(item => {
                item.time = TimeFormat.getFormatTime(item.time)
              })
            }
            this.tData = data
          })
        },
        getResource (init = false) {
          return autoInsepctionBiz.getResource({ system: this.searchForm.system || 0}).then((data) => {
            let obj = {}
            if (data) data.map(item => obj[item] = item)
            this.select_resource = obj
            this.searchForm.resourceType = ''
            if (!init) this.getItem()
          })
        },
        getItem () {
          return autoInsepctionBiz.getItem({ system: this.searchForm.system || 0,
              resourceType: this.searchForm.resourceType || '' }).then((data) => {
            this.select_item = data || {}
            this.searchForm.item = ''
          })
        },
        getSiteList () {
          SiteListBiz.siteList({perPageCount: 500}).then((data) => {
            let list = {}
            data.dataList.map((item) => {
              list[item.siteCode] = item.name
            })
            this.siteList = list
            this.searchForm.siteCode = Object.keys(this.siteList)[0]
            this.preInitTable()
            this.searchTable()
          })
        },
        e_export () {
          const search = extend({}, this.searchForm)
          if (!search.endTime) search.endTime = new Date().getTime()
          if (!search.system) search.system = 0
          if (!search.resourceType) search.resourceType = ''
          if (!search.resultType) search.resultType = 0
          if (!search.item) search.item = 0
          if (!this.doExport) this.doExport = this.exportOperation()
          this.doExport(search)
        },
        exportOperation () {
          const that = this
          const list = Object.assign({}, that.$t('autoInspectionReport.table'))
          const dictionary = []
          for (const key in DIC_MAP) {
            dictionary.push({
              relate: key,
              type: that.dDictionary[DIC_MAP[key]]
            })
          }
          dictionary.push({
            relate: 'siteCode',
            type: this.siteList
          })
          dictionary.push({
            relate: 'resourceType',
            type: this.select_resource
          })
          dictionary.push({
            relate: 'item',
            type: this.select_item
          })
          return function (search) {
            that.exRenderBefore()
            autoInsepctionBiz.export(
              list,
              search,
              ['time'],
              dictionary,
              that.exRenderTips,
              that.exRenderFail
            )
          }
        }
      },
      mounted () {
        this.getSiteList()
      }
    }
  </script>
  
  <style scoped>
  </style>